<template>
  <section>
    <error-display-component :serverErrors="serverErrors" :serverErrorMessage="serverErrorMessage" id="error-container"></error-display-component>
    <div class="hero">
      <div class="hero-body" ref="myhero">
        <div class="container box has-background-white-bis" ref="credite">
          <div class="columns is-multiline">
            <div class="column is-12">
            </div>
            <div class="column is-12">
              <form class="has-text-centered steps-content is-full" ref="formContainer" style="width: 100% !important;">
                <section class="has-text-left" id="contentContainer" ref='cropper'>
                  <div class="columns is-multiline" ref="columnContainer">
                    <div class="column is-12 box">
                      <div class="columns">
                        <div class="column is-6" v-if="hasServiceVideo">
                          <div class="field">
                            <label class="label">Video</label>
                            <video  style="height: 500px;" class="video_player" controls crossorigin>
                                <source :src="videoUrl" type="video/mp4" />
                            </video>
                          </div>
                        </div>
                        <div class="column is-6">
                          <section v-if="hasIncludedAttachments">
                            <label class="label">Media</label>
                            <figure class="image is-64xauto" @click="onViewServiceVideoImages" title="Click to view images">
                              <img :src="includedAttachments[0].fileLocation" style="max-width:200px">
                              <span ref="salesVideosImageViewer" v-viewer.static="{inline: false, title: true}">
                                <img v-for="attachment in includedAttachments" :key="attachment.id" :src="attachment.fileLocation" :alt="attachment.description" style="display:none"/>
                              </span>
                            </figure>
                        </section>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="notification has-background-grey-dark has-text-white">
                    Vehicle information
                  </div>
                  <div class="column is-12 box" v-if="vehicleAndVin">
                      <div class="field">
                        <label class="label">Vehicle</label>
                        <span class="is-inline-block">{{ vehicleAndVin }}</span>
                      </div>
                    </div>
                </section>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import customerMixin from '@/mixins/customer/index'
import validateBeforeSubmitMixin from '@/mixins/generic/validateBeforeSubmit'
import ErrorDisplayComponent from '@/components/generic/ErrorDisplayComponent'
import utilitiesMixin from '@/mixins/generic/utilities'
import { mapActions } from 'vuex'

export default {
  name: 'ServiceVehicleInformation',
  inject: {
    $validator: '$validator'
  },
  props: {
    token: {
      type: String,
      default: ''
    },
    serviceVideo: {
      type: Object,
      default: null
    },
    supplier: {
      type: Object,
      default: null
    },
    customer: {
      type: Object,
      default: null
    },
    attachmentMediaIds: {
      type: String,
      default: ''
    },
    vehicleInformation: {
      type: String,
      default: ''
    }
  },
  components: {
    'error-display-component': ErrorDisplayComponent
  },
  mixins: [validateBeforeSubmitMixin, customerMixin, utilitiesMixin],
  data () {
    return {
      mobile: window.innerWidth <= 700,
      isLoading: false,
      itemsHidden: true,
      currentStep: 0,
      serverErrors: [],
      serverErrorMessage: '',
      preventClick: false,
      currentUrl: '',
      showFileNameColumn: window.innerWidth > 500,
      windowContainerWidth: window.innerWidth
    }
  },
  computed: {
    currentScope: function () {
      return this.availableScopes[this.currentStep]
    },
    hasServiceVideo: function () {
      if (this.serviceVideo && this.serviceVideo.fileLocation) {
        return true
      }
      return false
    },
    videoUrl: function () {
      if (this.serviceVideo && this.serviceVideo.fileLocation) {
        const videoUrl = process.env.VUE_APP_LIVE_API + 'video/stream?url=' + encodeURI(this.serviceVideo.fileLocation)
        return videoUrl
      }
      return ''
    },
    includedAttachments: function () {
      const includedIdValues = this.attachmentMediaIds.split(',').map(Number)
      var result = []
      if (includedIdValues.length > 0 && this.serviceVideo && this.serviceVideo.attachments) {
        this.serviceVideo.attachments.forEach((attachment) => {
          const attachmentId = attachment.id
          if (includedIdValues.includes(attachmentId)) {
            const includedAttachment = {
              id: attachment.id,
              fileLocation: attachment.fileLocation,
              description: attachment.description
            }
            result.push(includedAttachment)
          }
        })
        return result
      }
      return []
    },
    hasIncludedAttachments: function () {
      if (this.includedAttachments && this.includedAttachments.length > 0) {
        return true
      }
      return false
    },
    vehicleAndVin: function () {
      if (this.serviceVideo && this.serviceVideo.vinNo && this.vehicleInformation) {
        return this.vehicleInformation + ', ' + this.serviceVideo.vinNo
      } else if (this.serviceVideo && this.serviceVideo.vinNo) {
        return this.serviceVideo.vinNo
      }
      return ''
    },
    serviceType: function () {
      if (this.serviceVideo && this.serviceVideo.serviceWalkaroundType) {
        return this.serviceVideo.serviceWalkaroundType
      }
      return ''
    },
    createdAt: function () {
      if (this.serviceVideo && this.serviceVideo.createdAt) {
        const date = new Date(this.serviceVideo.createdAt)
        return `${date.toLocaleDateString()}`
      }
      return ''
    }
  },
  methods: {
    ...mapActions(['updateReturnUrl', 'updateIsContinueLater']),
    getFileType: function (fileName) {
      if (!fileName) {
        return ''
      }
      var extension = fileName.split('.').pop()
      extension = extension.toLowerCase()
      if (extension === 'jpg' || extension === 'png' || extension === 'jpeg' || extension === 'gif') {
        return 'image/' + extension
      }
      if (extension === 'pdf' || extension === 'doc' || extension === 'txt') {
        return 'application/' + extension
      }
      return 'unknown'
    },
    onDownloadSalesVideo: function (row) {
      window.location = row.fileLocation
    },
    onViewServiceVideoImages: function () {
      const viewer = this.$refs.salesVideosImageViewer
      if (!viewer || !viewer.$viewer || typeof viewer.$viewer.show !== 'function') {
        // Prevent runtime errors when the directive hasn’t instantiated the viewer
        return
      }
      viewer.$viewer.show()
    },
    onViewServiceImages: function () {
      const viewer = this.$refs.inventoryImageViewer
      if (!viewer || !viewer.$viewer || typeof viewer.$viewer.show !== 'function') {
        // Prevent runtime errors when the directive hasn’t instantiated the viewer
        return
      }
      viewer.$viewer.show()
    }
  },
  created () {
    this.currentUrl = window.location.href
    this.$emit('is-home', false)
  },
  mounted () {
  },
  watch: {
  }
}

</script>

<style scoped>

</style>
